import * as yup from 'yup';
import urlRegex from '$/shared/frontend/utils/urls/urlRegex';
import { Mentionable } from '$/components/ui/EditableInput/types';

// Using as default mention fields for UrlInput
export const urlFields: Mentionable[] = [
  {
    name: '{ registrationLink }',
    title: 'Link back to landing page',
    isUrl: true,
  },
  {
    name: '{ replayLink }',
    title: "Link to attendee's replay session",
    isUrl: true,
  },
  {
    name: '{ allWebinarsLink }',
    title: 'Link to your share all webinars page',
    isUrl: true,
  },
];

export const isValidURL = (
  str: string,
  params: { strict: boolean } = { strict: false }
): boolean => {
  return urlRegex({ exact: true, strict: params.strict, allowSpacing: true }).test(str);
};

export const yupIsValidUrl = (
  message = 'Must enter a valid URL'
): yup.StringSchema<string | null> => {
  const links = urlFields.map((link) => link.name.replace(/[\s\{\}]/g, '')).join('|');
  return yup
    .string()
    .trim()
    .nullable()
    .test('urlCustom', message, (value) => {
      if (!value || new RegExp(`^\\{\\s*(${links})\\s*\\}$`, 'gi').test(value)) {
        return true;
      }

      return urlRegex({ exact: true, strict: false, allowSpacing: true }).test(value);
    });
};
